import OrderReviewPayment from "./OrderReviewPayment.vue";

export {OrderReviewPayment}
export default OrderReviewPayment
